module.exports = __webpack_public_path__ + "static/assets/57f5c040b2ec7c6f269042b4e1c32a03.png";